import { Pipe, PipeTransform } from '@angular/core';
import { isEmail } from '../helpers/utils.helpers';

@Pipe({
  name: 'email',
})
export class EmailPipe implements PipeTransform {
  transform(value: any, ...args: any[]): boolean {
    return isEmail(value);
  }
}
